import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import UploadBadge from "../../components/UploadBadge";
import UploadAudio from "../../components/UploadAudio";
import { createAudio, updateAudio } from "../../http/audio";
import Spinner from "../../components/Spinner";
import { toast } from "react-toastify";
import { handleToast } from "../../utils/common";
import CustomMultiSelect from "../../components/FormElements/MultiSelect";
import CustomTextField from "../../components/FormElements/CustomTextField";
import { uploadImage } from "../../http/uploads";
import OutlinedButton from "../../components/FormElements/Buttons/OutlinedButton";
import ContainedButton from "../../components/FormElements/Buttons/ContainedButton";
import AxiosInstance from "../../services/networkServices";
import { useDispatch } from "react-redux";
import { setLoading, showToast } from "../../store/slices/common";

const AddEditRap = ({
  openDialog,
  handleCloseDialog,
  selectedItem,
  edit,
  fetchList,
}) => {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState(selectedItem?.name || "");
  const [audio, setAudio] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [speed, setSpeed] = useState(1);
  const [audioDuration, setAudioDuration] = useState(0);
  const audioRefStatic = useRef(new Audio(selectedItem?.audio));
  const dispatch = useDispatch();
  console.log(selectedItem, "selectedItem");
  useEffect(() => {
    if (selectedItem?._id) {
      setTitle(selectedItem?.name);
      setAudio(selectedItem?.audio);
      setSpeed(selectedItem?.speed);
    }
  }, [selectedItem?._id]);
  const handleCloseDialogHandler = () => {
    if (audioRefStatic.current) {
      audioRefStatic.current.pause();
      audioRefStatic.current.currentTime = 0;
    }
    handleCloseDialog();
  };

  const handleImageUpload = (file) => {
    setImage(file);
  };

  const handleAudioUpload = (file) => {
    console.log(file, "file");
    setFileData(file);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", title);
    if (image) {
      formData.append("image", image);
    }
    if (fileData?.name) {
      formData.append("file", fileData);
    }
    if (selectedItem?._id) {
      formData.append("id", selectedItem?._id);
    }
    formData.append("speed", speed);
    try {
      dispatch(setLoading(true));
      if (!selectedItem?._id) {
        const resp = await AxiosInstance.post("/rap/add-audio", formData);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      } else {
        const resp = await AxiosInstance.put("/rap/edit-audio", formData);
        dispatch(showToast({ color: "success", msg: resp.data?.message }));
      }
      handleCloseDialog();
      fetchList();
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };
  return (
    <Dialog
      sx={{
        zIndex: 9,
        "& .MuiDialog-container .MuiPaper-elevation": {
          borderRadius: "8px",
          width: "420px",
        },
      }}
      open={openDialog}
      onClose={handleCloseDialogHandler}
    >
      <Box sx={{ padding: "20px 16px 0" }}>
        <DialogTitle
          sx={{ padding: "0 0 15px", textAlign: "center", fontWeight: 700 }}
        >
          {selectedItem?._id ? "Edit" : "Add"} Audio
        </DialogTitle>
      </Box>
      <DialogContent sx={{ padding: "10px 16px 0" }}>
        <Box mt={1}>
          <CustomTextField
            label="Title of the audio"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            inputProps={{
              maxLength: 30,
              style: { color: "black" },
            }}
          />
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", marginBottom: "10px" }}
          >
            {" "}
            Upload Image{" "}
            <span
              style={{ fontSize: "10px", color: "gray", fontWeight: 400 }}
            >{`(File size max limit 5mb)`}</span>{" "}
          </Typography>
          <UploadBadge
            onImageUpload={handleImageUpload}
            edit={edit}
            audio={true}
            selectedBadge={selectedItem}
          />
        </Box>
        <Box sx={{ marginTop: "10px" }}>
          <Typography
            sx={{ fontWeight: 600, fontSize: "14px", marginBottom: "3px" }}
          >
            {" "}
            Audio{" "}
            <span
              style={{ fontSize: "10px", color: "gray", fontWeight: 400 }}
            >{`(File size max limit 5mb)`}</span>{" "}
          </Typography>
          <Typography
            sx={{
              fontSize: "10px",
              color: "gray",
              mt: 0,
              mb: 2,
              fontWeight: 400,
            }}
          >
            {" "}
            The uploaded audio file must have a duration of exactly 90 seconds
            (1.5 minutes).{" "}
          </Typography>
          <UploadAudio
            setAudio={setAudio}
            setAudioDuration={setAudioDuration}
            selectedAudio={selectedItem}
            audioRefStatic={audioRefStatic}
            IS_RAP={true}
            handleAudioUpload={handleAudioUpload}
          />
          {(fileData || selectedItem?.audio) && (
            <Box sx={{ marginBottom: "10px", marginTop: "10px" }}>
              <Typography>Speed</Typography>
              <Select
                value={speed}
                defaultValue={1}
                onChange={(e) => setSpeed(e.target.value)}
                placeholder="audio speed"
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                sx={{
                  marginTop: "10px",
                  width: "70px",
                  color: "black",
                  height: "30px",
                }}
              >
                <MenuItem value="0.5">0.5</MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="1.5">1.5</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="2.5">2.5</MenuItem>
                <MenuItem value="3">3</MenuItem>
              </Select>
            </Box>
          )}
          {/* </Box> */}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0 16px 20px" }}>
        <OutlinedButton onClick={handleCloseDialogHandler} btnName={"Cancel"} />
        <ContainedButton
          onClick={handleSubmit}
          btnName={selectedItem?._id ? "Update" : "Add"}
        />
      </DialogActions>
    </Dialog>
  );
};
export default AddEditRap;
